import config from '@/config.js';
import { createApp } from 'vue';
import { Amplify } from 'aws-amplify';
import { AVPlugin } from 'vue-audio-visual';
import { createPinia } from 'pinia'
import 'aws-amplify/auth/enable-oauth-listener';
import { createSentryPiniaPlugin } from "@sentry/vue";

// CASL library for the permissions
import { Ability } from '@casl/ability';
import { abilitiesPlugin } from '@casl/vue';

import { createPermissions } from "./components/permissions"
import { createReplaceT } from "./components/replaceT"
import { createShowMessage } from "./components/showMessage"
import { createLocalizeMessage } from "./components/localizeMessage"
import vuetify from "./components/vuetify";
import i18n from "./components/i18n";
import Api from "./api/Api";
import App from "./App.vue";
import { createGoogleReCaptcha } from './plugins/GoogleReCaptcha';
import { createAppRouter } from './routes/router.js';

// import './components/common.css';
import VuePlyr from '@/components/globals/VuePlyr.vue';
import UtilityPodsErrors from '@/components/globals/UtilityPodsErrors.vue';
import UtilityNodesErrors from '@/components/globals/UtilityNodesErrors.vue';
import * as ErrorHandlers from '@/components/errorHandlers.js';

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import 'md-editor-v3/lib/style.css';
import 'swiper/swiper-bundle.css';
import './styles/layers.scss';
import './styles/icons/css/tubewayicons.css';
import './styles/fonts/fonts.css';
import './styles/main.scss'

Amplify.configure({
  Auth: config.Auth,
  Storage: config.Storage,
});

const app = createApp(App);
const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());
const router = createAppRouter(app);

ErrorHandlers.registerSentryErrorHandling(app, router);
ErrorHandlers.registerGTagErrorHandling(app, router);

app.config.errorHandler = (err, vm, info) => {
  ErrorHandlers.handleError(err, info);
  console.error(err);
};

// FixMe: properly define user abilities
app.use(abilitiesPlugin, new Ability(), {
  useGlobalProperties: true
});

app.use(vuetify);
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(AVPlugin);
app.use(createReplaceT());
app.use(createLocalizeMessage());
app.use(createShowMessage());
app.use(createPermissions());
app.use(createGoogleReCaptcha({ siteKey: config.recaptcha_site_key }));

// Global components
app.component('VuePlyr', VuePlyr);
app.component('UtilityPodsErrors', UtilityPodsErrors);
app.component('UtilityNodesErrors', UtilityNodesErrors);

Api.configure(app);

app.mount('#tubeway-app');
